import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=98fd377c&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fd377c",
  null
  
)

export default component.exports